export default function generateBase64Picture (buffer, extension) {
	let binary = ''
	const bytes = new Uint8Array(buffer)
	const len = bytes.byteLength
	for (var i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i])
	}
	const base64Img = window.btoa(binary)
	return `data:image/${extension};charset=utf-8;base64, ${base64Img}`
}



// WEBPACK FOOTER //
// ./src/utils/generateBase64Picture.js